import omit from 'lodash/omit';
import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import { getQuestionnaireRoute } from 'functions/getQuestionnaireRoute';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';

export const getDefaultUserCountry = () => {
  if (typeof navigator.languages !== 'undefined' && navigator.languages.length > 1) {
    return navigator.languages[0].slice(-2).toLowerCase() || null;
  }

  return navigator.language.slice(-2).toLowerCase() || null;
};

export const validate = (values) => {
  const errors = {};
  const requiredFields = ['email'];
  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });

  if (
    values.email
    // source: https://html.spec.whatwg.org/multipage/input.html#email-state-(type=email)
    // eslint-disable-next-line
    && /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
      values.email,
    )
  ) {
    errors.email = 'Invalid email address';
  }

  return errors;
};

export const createQuestionnaireRedirectURL = (indication) => {
  const [fistQuestion] = indication;

  if (fistQuestion?.id) {
    return getQuestionnaireRoute({ questionId: fistQuestion.id });
  }

  return ROUTE_PATH[ROUTE_NAME.LOGIN];
};

export const setTokens = (tj_access_token, tj_refresh_token) => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, tj_access_token);
  localStorage.setItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN, tj_refresh_token);
};

export const setSession = (data) => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.MASKED_EMAIL, data?.maskedEmail);
  localStorage.setItem(LOCAL_STORAGE_KEYS.MASKED_PHONE, data?.maskedPhone);
  localStorage.setItem(LOCAL_STORAGE_KEYS.ENC, JSON.stringify(data?.enc));
};

// comes from #749
// until supported
// TBD still relevant?
export const adjustMissingCriticalInfo = (data) => omit(
  data,
  ['currentStage', 'mProteinDetection', 'cllCharasterictics', 'cancerSubType', 'percentageOfBmBlasts', 'transplantationStatus'],
);

export const adjustConditionProfile = ({ insurances, ...rest }) => {
  const ensureArrayOrNull = (value) => {
    let result = value;
    if (typeof value === 'string') {
      result = value.split(',').filter((i) => i);
    }
    return !Array.isArray(result) || !result.length ? null : result;
  };
  return {
    ...rest,
    insurances: ensureArrayOrNull(insurances),
  };
};

export const formLocalStorageUserFromServerUser = (user) => {
  const {
    info: {
      user_wix_id,
      email,
      family_name = null,
      phone = null,
      user_type = null,
      partner = null,
      organization = null,
      platform = null,
    },
    personal: { condition, customerRef },
  } = user;
  return {
    user_wix_id,
    email,
    family_name,
    phone,
    user_type,
    partner,
    condition,
    organization,
    platform,
    customerRef: customerRef || null,
  };
};

export const formLoginResponseProfile = (loginResponse) => ({
  info: {
    user_wix_id: loginResponse.user_wix_id,
    email: loginResponse.email,
    family_name: loginResponse.family_name || null,
    phone: loginResponse.phone || null,
    user_type: loginResponse.user_type || null,
    country: loginResponse.country || null,
  },
  personal: {
    user_wix_id: loginResponse.user_wix_id,
  },
  condition_profile: {
    user_type: loginResponse?.user_type || null,
  },
});
